import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IAlertMessage } from '../../../../../shared/models/alert-message.interface';

export class RemainingBalanceValidator {
  static validate(value: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value > value) {
        const remainingBalanceOverflowMessage: IAlertMessage = {
          type: 'warning',
          text: 'views.specifications.contract_remaining_amount_overflow',
        };
        return { alertMessage: remainingBalanceOverflowMessage };
      }
      return null;
    };
  }
}
